import { render } from "./PurposeList.vue?vue&type=template&id=77c01138&ts=true"
import script from "./PurposeList.vue?vue&type=script&lang=ts"
export * from "./PurposeList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__